<template>
  <div class="cv-suggest">
    <w-popup-show :state="suggestState" @handleClose="handleClose">
      <div slot="content" class="suggest-container" @touchmove.prevent>
        <div class="header-container">
          <div class="suggest-header flex-between">
            <div class="suggest-title">
              <span class="title">优化建议</span>
              <span class="count" v-if="totalCount">（共{{ totalCount }}条）</span>
            </div>
            <span @click="$emit('handleClose')" class="iconfont iconx"/>
          </div>
          <p class="suggest-update-time" v-if="!checkOver && suggestTime">更新时间：{{ suggestTime | timeFormatFilter }}</p>
        </div>
        <div class="scroll-list-wrap">
          <cube-scroll ref="scroll" :data="suggestFields">
            <div class="suggest-wrapper">
              <!--              <div class="not-member" v-if="!member && !checkOver">每日可免费查看 1 次优化建议，升级会员 获得无限次数</div>-->
              <div class="result-wrapper" :class="{'not-member-wrapper': !member}" v-if="!checkOver">
                <div class="suggest-result">
                  <template v-for="(item,index) in suggestFields">
                    <div class="result-item" :key="index"
                         v-if="suggestions[item.field] && suggestions[item.field].length">
                      <div class="result-header flex-start" :key="index">
                        <img class="result-icon" :src="item.icon" alt="">
                        <span class="section-name">{{ item.title }}</span>
                        <span class="section-count">（{{ suggestions[item.field].length }}条）</span>
                      </div>
                      <div class="issue-wrapper">
                        <div class="issue-wrapper-placeholder" v-if="!userData.is_membership" @click="buyMember">
                          <img src="https://files.wondercv.com/mobile/cvs/examination-placeholder.png"/>
                        </div>
                        <template v-else>
                          <div class="issue flex-between" v-for="val in suggestions[item.field]" :key="val.id"
                             @click="suggestDetail(val, item)">
                            <span class="advice" :class="{'advice-change': val.hasChange}">{{ val.desc }}</span>
                            <span class="iconfont iconchevron-right"/>
                          </div>
                        </template>
                      </div>
                      <div class="ref-title flex-start" @click="toSuggestUrl(suggestions[item.field][0].article_url)"
                           v-if="suggestions[item.field] && suggestions[item.field][0] && suggestions[item.field][0].article_title">
                        <img src="https://files.wondercv.com/mobile/cvs/bell2.png" alt="">
                        <span>{{ suggestions[item.field][0].article_title }}</span>
                      </div>
                    </div>
                  </template>
                  <!-- <div class="flex-between community-detail-topic" @click="$router.replace('/community?currentTab=0')">
                    <div class="flex-start">
                      <img
                          src="https://prod-file-uploaded.oss-cn-beijing.aliyuncs.com/bbs/1f9747b0-f268-11ea-b1a7-9583858d9ef8.png"
                          alt="">
                      <div class="topic-info flex-column">
                        <span class="title">查看更多攻略</span>
                        <span class="community-num">19524人查看过</span>
                      </div>
                    </div>
                    <div class="topic-detail flex-center">去看看</div>
                  </div> -->
                </div>
              </div>
              <div class="flex-column not-count" v-else>
                <img src="https://files.wondercv.com/mobile/cvs/check-count.png" alt="">
                <p class="headline title">检查次数已用完</p>
                <p class="description">每日可使用<span class="theme-color"> 1 </span>次免费检查，<br><span
                    class="theme-color">升级会员</span>可查看全部优化建议</p>
                <div class="theme-button flex-center footer-btn" @click="buyMember">升级会员</div>
              </div>
            </div>
          </cube-scroll>
        </div>
        <div class="check-footer" v-if="!member && !checkOver" @click="buyMember">
          <button class="theme-button check-btn">升级会员查看优化建议</button>
        </div>
      </div>
    </w-popup-show>
  </div>
</template>

<script>
  import WPopupShow from '@/components/global/w-popup-show'
  import {mapState, mapActions, mapMutations} from 'vuex'
  import {envMixin} from '@/assets/js/mixin/global'
  import {componentsMixin} from '@/assets/js/mixin/components'
  import {rules} from '@/assets/json/rules'
  import {addClass, removeClass,} from '@/assets/js/dom'

  export default {
    name: 'cv-suggest',
    mixins: [envMixin, componentsMixin],
    props: {
      suggestState: {
        type: Boolean,
        default: false
      },
      member: {
        type: Boolean,
        default: false
      },
      notMemberAgainCheck: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        preDom: '',
        loadOver: false,
        checkOver: false,
        suggestionDetail: []
      }
    },
    mounted() {
      this._cvAutoSort()
    },
    computed: {
      ...mapState('cv', ['suggestions', 'suggestInfo', 'score', 'cv']),
      ...mapState('user', ['userData']),
      suggestFields() {
        return [
          {
            field: 'profile',
            title: '基本信息',
            icon: 'https://files.wondercv.com/%E5%9F%BA%E6%9C%AC%E4%BF%A1%E6%81%AF.png'
          },
          {
            field: 'edus',
            title: '教育经历',
            icon: 'https://files.wondercv.com/%E6%95%99%E8%82%B2%E7%BB%8F%E5%8E%86.png'
          },
          {
            field: 'works',
            title: '工作经历',
            icon: 'https://files.wondercv.com/%E5%B7%A5%E4%BD%9C%E7%BB%8F%E5%8E%86.png'
          },
          {
            field: 'global_result',
            title: '专业细节',
            icon: 'https://files.wondercv.com/%E4%B8%93%E4%B8%9A%E7%BB%86%E8%8A%82.png'
          },
          {
            field: 'others',
            title: '其他模块',
            icon: 'https://files.wondercv.com/%E5%85%B6%E4%BB%96%E6%A8%A1%E5%9D%97.png'
          },
        ]
      },
      totalCount() {
        let count = 0
        for (let key in this.suggestions) {
          if (this.suggestions[key] instanceof Array) count += this.suggestions[key].length
        }
        return count
      },
      suggestTime() {
        let {token} = this.$route.params
        return this.$db.ls.get(`${token}-suggestion-time`)
      }
    },
    watch: {
      suggestState(val) {
        if (val) {
          this.checkOver = false
          this.initSuggestions()
        }
      }
    },
    components: {
      WPopupShow,
    },
    methods: {
      ...mapActions('cv', ['cvAutoSort']),
      ...mapMutations('cv', ['changeSuggestInfo', 'changeSuggest']),
      handleClose() {
        this.$emit('handleClose')
      },
      // 点击在编辑页定位到位置并且高亮
      async suggestDetail(val, item) {
        let {basic_info: {token}} = this.cv
        let detail = val.highlights[0] || {}, rule
        if (val.name) rule = rules.filter(item => item.name === val.name)[0]
        if (val.name === 'cv_name?') {
          this.$emit('changeCv', 'cvName')
          this.handleClose()
        } else if (val.name === 'latest_not_first?') {
          if (!val.hasChange) this.cvAutoSort(true)
          this.handleClose()
        } else if (item.field === 'profile' && detail) {
          let suggestInfo = {field: detail.field, errorName: rule.title, errorDescription: val.desc, suggest: true}
          this.changeSuggestInfo(suggestInfo)
          this.$router.push(`/cvs/${token}/profiles`)
        } else if (detail && detail.whole_section) {
          let el = document.getElementById(detail.section)
          if (el) {
            this._dealElScroll(el)
          } else {
            this.$router.push(`/cvs/${token}/module`)
          }
        } else if ((item.field === 'edus' || item.field === 'works' || item.field === 'orgs') && detail) {
          let suggestInfo = {
            field: detail.field === 'start_at' || detail.field === 'end_at' ? 'datetime' : detail.field,
            errorName: rule.title,
            errorDescription: val.desc,
            suggest: true
          }
          this.changeSuggestInfo(suggestInfo)
          this.$router.push(`/cvs/${token}/${detail.section}/${detail.section_id}/edit`)
        } else if (item.field === 'global_result' && detail) {
          if (val.name === 'line_item_more_than?') {
            let el = document.getElementById(detail.section_id)
            this._dealElScroll(el)
          } else if (detail) {
            let suggestInfo = {
              errorName: rule.title,
              errorDescription: val.desc,
              suggest: true,
              highlight: detail.highlight,
              highlightSave: true
            }
            this.changeSuggestInfo(suggestInfo)
            const infos = detail.section === 'custom' ? this.$store.state.cv[detail.section_id] : this.$store.state.cv[detail.section]
            const index = infos.findIndex(item => item.id === detail.section_id || item.id === detail.section_info_id)
            if (detail.section_info_id) {
              this.$router.push(`/cvs/${token}/${detail.section_id}/${detail.section}/${detail.section_info_id}/content_edit`)
            } else {
              this.$router.push(`/cvs/${token}/${detail.section}/${detail.section_id}/content_edit`)
            }
          } else if (detail.field === 'description') {
            let suggestInfo = {
              errorName: rule.title,
              errorDescription: val.desc,
              suggest: true,
              highlight: detail.highlight,
              highlightSave: true
            }
            this.changeSuggestInfo(suggestInfo)
            this.$router.push(`/cvs/${token}/${detail.section}/${detail.section_id}/content_edit`)
          } else {
            let suggestInfo = {field: detail.field, errorName: rule.title, errorDescription: val.desc, suggest: true}
            this.changeSuggestInfo(suggestInfo)
            this.$router.push(`/cvs/${token}/${detail.section}/${detail.section_id}/content_edit`)
          }
        } else if (item.field === 'others') {
          let errorName = val.name === 'languages_blank?' ? '添加语言能力' : val.name === 'skills_blank?' ? '建议添加技能' : ''
          let field = val.name === 'languages_blank?' ? 'language' : val.name === 'skills_blank?' ? 'skill' : ''
          let suggestInfo = {errorName, field, errorDescription: val.desc, suggest: true}
          this.changeSuggestInfo(suggestInfo)
          this.$router.push(`/cvs/${token}/extras`)
        }
      },
      // 哪段经历里面有空行
      _oneLineDisplay() {
        let oneLineAry = [
          ...this.cv.edus,
          ...this.cv.orgs,
          ...this.cv.works,
        ]
        this.cv.custom_sections.forEach(item => {
          item.custom_section_infos.forEach(val => {
            oneLineAry.push(val)
          })
        })
        for (let i = 0; i < oneLineAry.length; i++) {
          if (oneLineAry[i].need_oneline_display) {
            let el = document.getElementById(oneLineAry[i].id)
            this._dealElScroll(el)
          }
        }
      },
      // 处理dom高亮整个模块
      _dealElScroll(el) {
        if (el) {
          this.$emit('handleClose')
          if (this.preDom) removeClass(this.preDom, 'high-light-error')
          addClass(el, 'high-light-error')
          this.$nextTick(() => {
            window.scrollTo({behavior: 'smooth', top: el.offsetTop - 128})
            this.preDom = el
          })
        } else {
          this.showToast('该建议已失效', 1500)
        }
      },
      // 跳转至blog
      toSuggestUrl(url) {
        window.location.href = url
      },
      // 跳转至会员
      toMember() {
        if (this.$isWxMini) {
          this.$wechat.miniProgram.navigateTo({ url: '/pages/memberPay/memberPay' })
        } else {
          this.$router.push({path:'/buy/member/order'})
        }
        // this.$router.push(`/buy/member/order`)
        // this.routeTo('/account/users/buy_member')
      },
      // 非会员点击智能检查按钮
      changeCheckOver() {
        this.checkOver = true
      },
      // 非会员初始化建议
      initSuggestions() {
        let {token} = this.$route.params
        let localSuggest = this.$db.ls.get(`${token}-suggestion`)
        let newSuggestions = JSON.parse(JSON.stringify(this.suggestions))
        if (this.notMemberAgainCheck) {
          for (let key in localSuggest) {
            localSuggest[key].forEach(item => {
              const index = newSuggestions[key] && newSuggestions[key].findIndex(val => val.name === item.name)
              if (index === -1) {
                item.hasChange = true
              } else if (newSuggestions[key]) {
                let values = this.contrastData(item.highlights, newSuggestions[key][index].highlights)
                item.highlights = values || item.highlights
                if (values && !values.length) item.hasChange = true
              }
            })
          }
          this.changeSuggest({score: this.score, suggestions: localSuggest})
        }
      },
      // 对比两个highLight数组中的相同和不同的数据
      contrastData(oldVal, newVal) {
        return oldVal.filter(item => {
          return newVal.findIndex(val => val.section_id === item.section_id) > -1
        })
      },
      // 简历自动排序
      _cvAutoSort() {
        let cvData = {
          cv: this.cv
        }
        let {submodule_info: {sections_position}} = this.cv
        sections_position.forEach(item => {
          if (item.type === 'custom') {
            cvData[item.id] = this.$store.state.cv[item.id]
          } else if (item.type === 'extras') {
            cvData.extras = this.$store.state.cv.extra
          } else {
            cvData[item.type] = this.$store.state.cv[item.type]
          }
        })
      },
      buyMember(){
        this.$fn.jump(
          `/pages/member-buy/index`,
          () => {
            this.$router.push(`/buy/member/order`)
          }
        )
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/global/mixin';

  .cv-suggest {
    .suggest-container {
      width: 100vw;
      height: 80vh;

      .scroll-list-wrap {
        height: calc(80vh - 62px);
      }

      .header-container {
        padding: 16px 26px;
        border-bottom: 1px solid #e3e3e3;

        .suggest-header {
          margin-bottom: 8px;

          .suggest-title {
            font-weight: 500;

            .title {
              font-size: $font-size-medium-x;
              color: $color-title;
              font-weight: 600;
            }

            .count {
              font-size: $font-size-medium;
              color: $color-dark-gray;
            }
          }

          .iconfont {
            color: $color-light-gray;
            font-size: $font-size-large-x;
            font-weight: bold;
          }
        }

        .suggest-update-time {
          font-size: $font-size-small;
          color: #9C9C9C;
        }
      }

      .not-member {
        width: calc(100vw - 52px);
        margin: 26px auto 0;
        padding: 10px 20px;
        color: $color-theme;
        line-height: 20px;
        background-color: #f9f9f9;
        border-radius: 4px;
      }

      .result-wrapper {
        .suggest-result {
          .result-item {
            padding: 22px 26px;

            .result-header {
              margin-bottom: 24px;

              .result-icon {
                width: 18px;
                margin-right: 10px;
              }

              .section-name {
                color: $color-title;
                font-weight: 500;
              }

              .section-count {
                color: $color-dark-gray;
                font-weight: 400;
              }
            }

            .issue-wrapper {
              .issue-wrapper-placeholder{
                // height: 70px;
                margin-bottom: 10px;
                img{
                  display: block;
                  width: 100%
                }
              }
              .issue {
                margin-bottom: 20px;

                .advice {
                  margin-right: 24px;
                  line-height: 20px;
                  color: $color-title;
                }

                .advice-change {
                  text-decoration: line-through;
                }

                .iconchevron-right {
                  font-weight: bold;
                  font-size: $font-size-medium-x;
                  color: $color-light-gray;
                }
              }
            }

            .ref-title {
              height: 42px;
              border-radius: 4px;
              background-color: rgba(255, 102, 68, .1);
              padding-left: 24px;
              color: #FF6644;
              img {
                width: 13px;
                margin-right: 14px;
                vertical-align: middle;
                margin-bottom: 2px;
              }
            }
          }
        }
      }

      .not-member-wrapper {
        padding-bottom: 76px;
      }

      .not-count {
        height: calc(80vh - 63px);
        align-items: center;
        padding-top: 25%;

        img {
          width: 105px;
          margin-bottom: 16px;
        }

        .title {
          margin-bottom: 10px;
        }

        .description {
          text-align: center;
          line-height: 20px;
          color: #9c9c9c;
          margin-bottom: 40px;

          .theme-color {
            color: $color-theme;
          }
        }

        .footer-btn {
          width: 200px;
          height: 38px;
          border-radius: 2px;
        }
      }

      .check-footer {
        width: 100vw;
        position: absolute;
        bottom: 0;
        padding: 10px 25px 20px;
        background-color: $color-light;
        z-index: 9;

        .check-btn {
          width: 100%;
          height: 46px;
          border-radius: 4px;
          font-size: $font-size-medium-x;
        }
      }
    }
  }

  .community-detail-topic {
    padding: 8px 16px;
    background-color: #F9F9F9;
    border-radius: 4px;
    margin: 16px 24px;
    img {
      width: 42px;
      height: 42px;
      border-radius: 4px;
      margin-right: 10px;
      object-fit: cover;
    }

    .topic-info {
      justify-content: space-between;

      .title {
        font-size: 16px;
        font-weight: 600;
        color: $color-dark-gray;
        margin-bottom: 10px;
      }

      .community-num {
        color: #9C9C9C;
        font-size: $font-size-small;
      }
    }

    .topic-detail {
      width: 60px;
      height: 26px;
      border-radius: 14px;
      background-color: #ececec;
      color: #606060;
      font-size: $font-size-small;
    }
  }
</style>
